export default [
  {
    id: 1,
    name: "Ukraine",
  },
  {
    id: 2,
    name: "Germany",
  },
  {
    id: 3,
    name: "France",
  },
  {
    id: 4,
    name: "Spain",
  },
  {
    id: 5,
    name: "USA",
  },
  {
    id: 6,
    name: "Armenia",
  },
];
